import { auth } from '../../firebase.config';

export class NotSignedInError extends Error {
    constructor() {
        super('Not signed in');
        this.name = 'NotSignedInError';
    }
}

// Waits for Firebase to restore the session first: on a hard reload
// currentUser is briefly null, and reading getIdToken off it threw a
// TypeError before any request was sent.
//
// The admin role lives in the token's custom claims, so a cached token can
// carry a stale role. Only getIsAdmin (called by the router guard on every
// admin navigation) forces a refresh; every other call reuses that token
// instead of minting a new one per request.
export async function adminAuthHeaders({ forceRefresh = false } = {}) {
    await auth.authStateReady();
    const user = auth.currentUser;
    if (!user) throw new NotSignedInError();
    const accessToken = await user.getIdToken(forceRefresh);
    return { Authorization: `Bearer ${accessToken}` };
}
